import { render, staticRenderFns } from "./CustomerShipmentDataDashboard.vue?vue&type=template&id=557d07c2&scoped=true&"
import script from "./CustomerShipmentDataDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerShipmentDataDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d07c2",
  null
  
)

export default component.exports